/**
 * Pricing lane separation: owner/host plans vs client premium vs future partner plans.
 */

export const PRICING_LANE_OWNER = 'owner';
export const PRICING_LANE_CLIENT = 'client';
export const PRICING_LANE_PARTNER = 'partner';

export const OWNER_PRICING_PUBLIC_PATH = '/pricing';
export const OWNER_PRICING_OWNER_PATH = '/owner/plans';
export const CLIENT_PREMIUM_REDIRECT_PATH = '/dashboard';

export const CLIENT_PREMIUM_PRICING_LANE_TEST_ID = 'client-premium-pricing-lane';
export const OWNER_PRICING_LANE_TEST_ID = 'owner-pricing-lane';

const ROLE_USER = 'USER';

/** Owner-plan feature labels pure clients must never see in their pricing lane. */
export const OWNER_PLAN_FEATURE_MARKERS = [
  'Property Listings',
  'Photos per Listing',
  '1 Active Listing',
  '5 Active Listings',
  'pricing.feature.max_listings',
  'pricing.feature.photos_per_listing',
  'pricing.btn_upgrade',
];

export function shouldUseClientPremiumPricingLane({ user, isAdmin, viewAsRole }) {
  if (!user) {
    return false;
  }
  if (isAdmin && viewAsRole === ROLE_USER) {
    return true;
  }
  if (isAdmin) {
    return false;
  }
  return String(user.role || '').toUpperCase() === ROLE_USER;
}

export function canAccessOwnerPricingLane({ user, isAdmin, viewAsRole }) {
  if (!user) {
    return true;
  }
  return !shouldUseClientPremiumPricingLane({ user, isAdmin, viewAsRole });
}

export function resolvePricingLane({ user, isAdmin, viewAsRole }) {
  if (!user) {
    return PRICING_LANE_OWNER;
  }
  if (shouldUseClientPremiumPricingLane({ user, isAdmin, viewAsRole })) {
    return PRICING_LANE_CLIENT;
  }
  return PRICING_LANE_OWNER;
}

export function getClientPricingRouteRedirect(pathname, { user, isAdmin, viewAsRole }) {
  if (!shouldUseClientPremiumPricingLane({ user, isAdmin, viewAsRole })) {
    return null;
  }

  const path = pathname || '';
  if (path === OWNER_PRICING_PUBLIC_PATH || path === OWNER_PRICING_OWNER_PATH) {
    return CLIENT_PREMIUM_REDIRECT_PATH;
  }

  return null;
}

export function ownerPricingDestinationForRole({ user, isAdmin, viewAsRole }) {
  if (shouldUseClientPremiumPricingLane({ user, isAdmin, viewAsRole })) {
    return CLIENT_PREMIUM_REDIRECT_PATH;
  }
  return OWNER_PRICING_OWNER_PATH;
}
